import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    theme: "#409EFF",
    navData: [],
  },
  getters: {},
  mutations: {
    changeLoading(state, data) {
      state.loading = data;
    },
    changeNavData(state, data) {
      state.navData = data;
    },
  },
  actions: {},
  modules: {},
});
